import React from "react";
// import { IPortDefaultProps } from "@mrblenny/react-flow-chart";
// import { Icon } from "semantic-ui-react";

const PortCustom = props => {
  return <div>{/* <Icon name="caret down" size="large" /> */}</div>;
};

export default PortCustom;
